import axios from 'axios';
import { BASE_URL } from './api';

export async function getDLAGoverningSpecifications(token) {
    return axios({
        method: "get",
        url: `${BASE_URL}/dla_companies/dla_governing_specifications`,
        headers: {
            'Authorization': `Token ${token}`
        }
    })
    .then(response => response.data.dla_governing_specifications)
    .catch(error => console.error(error))

}